// DraggableEditor.js
import React, { useRef, useState } from "react";
import { Paper, Dialog, DialogTitle, styled } from "@mui/material";
import { AppStyle } from "../value/AppConst";

const ClassDraggableTitle = 'draggable-title-for-editor';

const IconBox = styled('div')({
    marginRight: 10,
});

const EditorTitle = styled(DialogTitle)({
    backgroundColor: AppStyle.HeaderBackgroundColor,
    color: 'white',
    minWidth: 300, display: 'flex', alignItems: 'center',
});

const DraggablePaper = (props) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [dragging, setDragging] = useState(false);
    const dragRef = useRef(null);

    const onMouseDown = (e) => {
        if(e.target.closest(`.${ClassDraggableTitle}`)) {
            setDragging(true);
            dragRef.current = {
                offsetX: e.clientX - position.x,
                offsetY: e.clientY - position.y,
            };
        }
    };

    const onMouseMove = (e) => {
        if (dragging) {
            setPosition({
                x: e.clientX - dragRef.current.offsetX,
                y: e.clientY - dragRef.current.offsetY,
            });
        }
    };

    const onMouseUp = () => {
        setDragging(false);
    };

    const childrenArray = props.children.props.children;

    return (
        <Paper
            {...props}
            style={{
                transform: `translate(${position.x}px, ${position.y}px)`
            }}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
        >
            <div className={ClassDraggableTitle}
                onMouseDown={onMouseDown}
                style={{cursor: 'move'}}
            >
                {childrenArray[0]}
            </div>
            {childrenArray.slice(1)}
        </Paper>
    );
};

export default function DraggableEditor({
    children,
    open,
    onClose,
    startIcon,
    title,
    maxWidth='lg',
    style,
    dialogStyle,
    fullScreen,
}) {
    if(!open) return null;

    const newStyle = dialogStyle ? dialogStyle : undefined;
    return(
        <Dialog open={open} maxWidth={maxWidth}
            PaperComponent={DraggablePaper}
            style={newStyle}
            fullScreen={fullScreen}
            onClose={()=>{ if(onClose) onClose(); }}
        >
            <EditorTitle style={style}>
                {
                    startIcon && (
                        <IconBox>
                            {startIcon}
                        </IconBox>
                    )
                }
                {title}
            </EditorTitle>
            {children}
        </Dialog>
    );
}